package tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet

import co.touchlab.kermit.Logger
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.essenty.lifecycle.doOnDestroy
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch
import org.koin.core.component.KoinComponent
import tta.destinigo.talktoastro.feature_call_consultation.data.request.JoinQueueRequest
import tta.destinigo.talktoastro.feature_call_consultation.data.response.join_queue.JoinQueueData
import tta.destinigo.talktoastro.feature_call_consultation.domain.QueueRepo
import tta.destinigo.talktoastro.feature_call_consultation.persentation.queue_bottomsheet.model.ConsultationData
import tta.destinigo.talktoastro.shared.data.CommonExpertInfo
import tta.destinigo.talktoastro.shared.data.QueueOption
import tta.destinigo.talktoastro.shared.remote.Resources

class QueueComponent(
    componentContext: ComponentContext,
    val commonExpertInfo: CommonExpertInfo,
    val consultationType: String?,
    val onDismiss: (isQueueJoined: Boolean) -> Unit,
    val callConsultationData: ConsultationData,
    val chatConsultationData: ConsultationData
) : ComponentContext by componentContext, KoinComponent {

    private val coroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val scope = getKoin().createScope<QueueComponent>()
    private val repository: QueueRepo by scope.inject()

    private val _queueType = MutableStateFlow(QueueOption.CALL)
    val queueType = _queueType.asStateFlow()

    private val _joinQueueState = MutableStateFlow<Resources<JoinQueueData>?>(null)
    val joinQueueState = _joinQueueState.asStateFlow()

    fun onOptionSelected(type: QueueOption) {
        coroutineScope.launch {
            _queueType.emit(type)
        }
    }

    fun onJoinQueue() {
        val request = JoinQueueRequest(
            expertId = commonExpertInfo.expertId.toString(),
            consultationType = queueType.value.name
        )
        coroutineScope.launch {
            onAddInQueue(request)
        }
    }

    init {
        onOptionSelected(
            if (consultationType.equals(
                    "chat",
                    true
                )
            ) QueueOption.CHAT else QueueOption.CALL
        )


        lifecycle.doOnDestroy {
            coroutineScope.cancel()
        }
    }

    private suspend fun onAddInQueue(joinQueueRequest: JoinQueueRequest) {
        repository.joinQueue(joinQueueRequest).collect {
            _joinQueueState.emit(it)
        }
    }

    private fun logMe(msg: String) {
        Logger.d(tag = "QUEUE_COMPONENT", messageString = msg)
    }

}